import { Stack } from '@mui/material'
import { t } from 'i18next'
import { useEffect, useRef, useState } from 'react'

import Can from '../../Layout/Can/Can.jsx'
import Filter from '../../Layout/Dialogs/Filter.jsx'
import Count from '../../Shared/Components/Count.jsx'
import { useAuth } from '../../Shared/Contexts/AuthContext.jsx'
import { OrganizationsFilter } from '../../Shared/Filters/Fields/index.js'
import RolesFilter from './Filters/RolesFilter.jsx'

const Filters = ({ onChange, filters, itemsCount }) => {
  const [selectedRoles, setSelectedRoles] = useState(false)
  const [selectedOrganizations, setSelectedOrganizations] = useState(false)
  const [announcementUpdatePage, setAnnouncementUpdatePage] = useState('')
  const shouldAnnounceUpdatePage = useRef(false)
  const previousItemsCount = useRef(itemsCount)

  const { authState } = useAuth()

  const handleOnDeleteRoles = () => {
    onChange({
      ...filters,
      roleIds: []
    })
    setSelectedRoles(false)
    shouldAnnounceUpdatePage.current = true
  }

  const handleOnDeleteOrganizations = () => {
    onChange({
      ...filters,
      organizationKeys: [],
      searchInSubOrganizations: false
    })
    setSelectedOrganizations(false)
    shouldAnnounceUpdatePage.current = true

  }

  const handleChangeRoles = (data) => {
    setSelectedRoles(true)
    onChange({
      ...filters,
      ...data
    })
  }

  const handleChangeOrganizations = (data) => {
    setSelectedOrganizations(true)
    onChange({
      ...filters,
      ...data
    })
  }

  const handleFilterClose = () => {
    shouldAnnounceUpdatePage.current = true
    announceUpdatePage()
  }

  const getAnnouncementMessage = () => {
    if (itemsCount === 0) {
      return t('filters.accessibility.noItemsFound')
    } else if (itemsCount === 1) {
      return t('filters.accessibility.oneItemFound')
    } else {
      return t('filters.accessibility.itemsFound', { count: itemsCount })
    }
  }

  const announceUpdatePage = () => {
    setAnnouncementUpdatePage('')

    setTimeout(() => {
      setAnnouncementUpdatePage(getAnnouncementMessage())
    }, 100)
  }

  useEffect(() => {
    if (shouldAnnounceUpdatePage.current && previousItemsCount.current !== itemsCount) {
      announceUpdatePage()
      shouldAnnounceUpdatePage.current = false
    }
    previousItemsCount.current = itemsCount
  }, [itemsCount])

  const filterUnits = [
    {
      label: t('common.role'),
      selected: selectedRoles,
      onDelete: handleOnDeleteRoles,
      onClose: handleFilterClose,
      content: (
        <RolesFilter
          onChange={handleChangeRoles}
          filters={filters}
        />
      ),
      count: <Count itemsCount={itemsCount} />
    },
    {
      label: t('common.organization'),
      selected: selectedOrganizations,
      onDelete: handleOnDeleteOrganizations,
      onClose: handleFilterClose,
      hidden: !authState.isAuthenticated,
      content: (
        <OrganizationsFilter
          onChange={handleChangeOrganizations}
          filters={filters}
        />
      ),
      count: <Count itemsCount={itemsCount} />
    }
  ]

  return (
    <>
      {/* Live region per annunci screen reader */}
      <div
        role="status"
        aria-live="polite"
        aria-atomic="true"
        style={{
          position: 'absolute',
          left: '-10000px',
          width: '1px',
          height: '1px',
          overflow: 'hidden'
        }}
      >
        {announcementUpdatePage}
      </div>
      <Stack
        direction="row"
        justifyContent="flex-start"
        alignItems="center"
        spacing={2}
      >
        {[...filterUnits].map((e, i) => (
          <Can
            action="users_r"
            key={`user-filter-${i}`}
          >
            <Filter
              id={`button-filter-${e.label}`}
              key={`user-filter-${i}`}
              onClick={e.onClick}
              onDelete={e.onDelete}
              onClose={e.onClose}
              selected={e.selected}
              title={e.label}
              hidden={e.hidden || false}
              content={e.content}
              count={e.count}
            />
          </Can>
        ))}
      </Stack>
    </>
  )
}

export default Filters
